export function unwrapData(body) {
  if (body == null) {
    return body;
  }
  if (typeof body !== 'object') {
    return body;
  }
  if (Object.prototype.hasOwnProperty.call(body, 'data') && body.data != null) {
    return body.data;
  }
  return body;
}

export default unwrapData;
